export default "__VITE_ASSET__v9w6ystw__"